import * as styles from './Option.scss';
import cn from 'classnames';
import React from 'react';
import { ResultsType as ResultsPropType } from 'app/hooks/useResults';
import { highlightText, ListBoxOptionType } from '@flixbus/honeycomb-react';
import { AutocompleteResult, AutocompleteResultStation } from 'app/models/types/store/location';
import { Icon, IconTrain, IconBus } from 'app/icons';
import { useTranslations } from 'app/hooks/useTranslations';
import { a11yLabelsKeys } from 'app/providers/a11yLabels';
import { useAppSelector } from 'app/hooks/appHooks';
import { flixTrainSelector } from 'app/store/selectors';

type OptionPropTypes = {
  value: string;
  resultType: ResultsPropType;
  item: ListBoxOptionType;
  citiesById: Record<
    string,
    AutocompleteResult & {
      positionOnList: number;
      station: AutocompleteResultStation;
      filteredStations: AutocompleteResultStation[];
    }
  >;
  direction: 'from' | 'to';
};
export const Option = ({ value, resultType, item, citiesById, direction }: OptionPropTypes) => {
  const { getTrainStationLabel, getAllStopsDepartureLabel, getAllStopsArrivalLabel } =
    useTranslations(
      {
        getAllStopsDepartureLabel: 'search_mask.label.all_stops.departure',
        getAllStopsArrivalLabel: 'search_mask.label.all_stops.arrival',
        getTrainStationLabel: a11yLabelsKeys.trainStation,
      },
      true,
    );
  const isFlixTrainDomain = useAppSelector(flixTrainSelector);

  const cityData = item.value ? citiesById[item.value] : undefined;

  const isTrain = cityData?.station?.is_train;

  return (
    <>
      {cityData && (
        <div
          className={cn(styles.optionWrapper, {
            [styles.station]: cityData.isStation,
          })}
        >
          <div className={cn('notranslate', styles.option)}>
            <div className={styles.cityName}>
              {cityData.isStation && (
                <Icon
                  appearance="primary"
                  extraClasses={styles.pinIcon}
                  aria-hidden={!isTrain}
                  aria-label={isTrain ? getTrainStationLabel() : ''}
                  InlineIcon={isTrain ? IconTrain : IconBus}
                />
              )}
              {highlightText(item.title, value)}
              {!!cityData.filteredStations?.length &&
                (cityData.filteredStations?.length > 1 || isFlixTrainDomain) &&
                resultType === 'autocomplete' && (
                  <span className={styles.allStopsLabel}>
                    (
                    {direction === 'from' ? getAllStopsDepartureLabel() : getAllStopsArrivalLabel()}
                    )
                  </span>
                )}
            </div>
            <div className={styles.additionalInfo}>{item.subtitle}</div>
          </div>
        </div>
      )}
    </>
  );
};
